<template src="./forms/subject_form.html"></template>

<script>
import { EditSubject, GetAssistItems } from '@/api/subject'

export default {
  name: 'edit-subject',
  data: function () {
    return {
      showReviewBtn: false,
      sites: {},
      rules: {
        screenid: [{
          required: true,
          message: '筛选号不能为空',
          trigger: 'change'
        }],
        inver: [{
          required: true,
          message: '研究者不能为空',
          trigger: 'change'
        }],
        subjid: [{
          required: true,
          message: '受试者编号',
          trigger: 'change'
        }],
        siteid: [{
          required: true,
          message: '研究中心不能为空',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '姓名拼音缩写不能为空',
          trigger: 'change'
        }]
      }
    }
  },
  props: ['model'],
  created: function () {
    this.getItems()
  },
  methods: {
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        }
      })
    },
    getItems: function () {
      GetAssistItems(this.$route.params.id).then(async res => {
        this.sites = res.sites
      })
    },
    postForm: function () {
      EditSubject(this.model.usubjid, this.model).then(async res => {
        if (res.usubjid) {
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
